import { Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DialogService } from '@seepex/ng-base';

import { AuthService } from 'src/app/auth/services/auth.service';
import { AuthCodeFlowConfig } from 'src/app/auth/auth.config';
import { User } from 'src/app/auth/models/user.model';
import { LanguageService } from 'src/app/services';
import { InfoDialogComponent } from './../info-dialog/info-dialog.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  static RESET_PASSWORD_URL = `${AuthCodeFlowConfig.issuer}/password/change`;
  public name?: string;
  public currentLang: string;
  public supportedLangs: string[];
  public showApps: boolean = false;
  // public appDrawerUrl: string = `${environment.portalUrl}/drawer/my-apps`;

  constructor(private authService: AuthService, private languageService: LanguageService, private dialog: DialogService) {
    this.currentLang = this.languageService.getCurrentLanguage();
    this.supportedLangs = this.languageService.getSupportedLanguages();
  }

  ngOnInit(): void {
    const user: User = this.authService.userInfo;
    this.name = user.name;

    // tperetzke - 2025-11-27:
    //
    // Feature temporarily disabled due to new browser warnings regarding missing "Local Network Access permission"
    // (introduced in Chrome 142 / portal is affected because it operates on local network resources which are ending
    // on '.local' like 'portal-api.seepex.local' / see https://developer.chrome.com/blog/local-network-access)
    //
    // window.onmessage = function (e) {
    //   if (e.origin === environment.portalUrl) {
    //     window.open(e.data, '_self');
    //     console.log(e);
    //   }
    // };
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event: any) {
    this.showApps = false;
    event.stopPropagation();
  }

  public logout(): void {
    this.authService.logout();
  }

  public changePassword(): void {
    const accessToken = this.authService.accessToken;

    window.location.href = `${HeaderComponent.RESET_PASSWORD_URL}?token=${accessToken}`;
  }

  public getLanguageName(lang: string): Observable<string> {
    return this.languageService.getLanguageName(lang);
  }

  public changeLanguage(lang: string): void {
    this.currentLang = this.languageService.changeLanguage(lang);
  }

  public showInfo(): void {
    this.dialog.openDialogWithComponent(InfoDialogComponent, 'APP_INFO');
  }

  public onShowApps() {
    this.showApps = !this.showApps;
  }
}
